export default function Carregando({ texto = 'Carregando' }: { texto?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 p-10 text-sm text-mute" role="status">
      <span
        className="h-4 w-4 animate-spin border-2 border-edge border-t-signal"
        aria-hidden="true"
      />
      {texto}…
    </div>
  );
}
